import React from 'react';
import { Table } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';

const PAGE_SIZE = 10;
const momentFormat = 'YYYY-MM-DD HH:mm:ss';

const getStatusColor = status => {
  switch (status) {
    case 'success':
      return '#36b37e';
    case 'failed':
      return '#ff5630';
    case 'running':
      return '#00b8d9';
    default:
      return 'rgba(0, 0, 0, 0.65)';
  }
};

const CronRunsTable = ({ runs, total, loading, page, onPageChange }) => {
  if (!loading && isEmpty(runs)) {
    return <div>No cron run history found.</div>;
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Cron run ID',
      dataIndex: 'cronRunId',
      key: 'cronRunId',
    },
    {
      title: 'Month',
      dataIndex: 'monthKey',
      key: 'monthKey',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: status => (
        <span style={{ color: getStatusColor(status), fontWeight: 'bold' }}>
          {status}
        </span>
      ),
    },
    {
      title: 'Trigger',
      dataIndex: 'triggerSource',
      key: 'triggerSource',
    },
    {
      title: 'Hub',
      dataIndex: 'hub',
      key: 'hub',
    },
    {
      title: 'Processed',
      key: 'processed',
      render: (_, row) =>
        `${row.totalSuccess || 0}/${row.totalRecordsProcessed || 0}`,
    },
    {
      title: 'Failed',
      dataIndex: 'totalFailed',
      key: 'totalFailed',
    },
    {
      title: 'Retries',
      dataIndex: 'retryCount',
      key: 'retryCount',
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: value => (value ? moment(value).format(momentFormat) : null),
    },
  ];

  return (
    <Table
      scroll={{ x: 'max-content' }}
      loading={loading}
      columns={columns}
      dataSource={runs.map(run => ({ ...run, key: run.id }))}
      pagination={{
        total,
        pageSize: PAGE_SIZE,
        current: page,
      }}
      onChange={({ current }) => onPageChange(current)}
    />
  );
};

export default CronRunsTable;
